//noinspection JSFileReferences
import index from './shared/index.js';

index.init();